var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            title: _vm.title,
            "inline-message": "",
            width: "1300px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "details-view" }, [
            _c("div", { staticClass: "commerce_content" }, [
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { "margin-bottom": "10px" }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "5px" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: !_vm.isEdit,
                            inline: "",
                            "label-width": "80px",
                            "label-position": "top",
                            width: "100%"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AirlineCode"),
                                required: true
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "385px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  filterable: "",
                                  "default-value": _vm.commerceForm.code,
                                  "filter-type": "global",
                                  "filter-tag-names": [
                                    "code",
                                    "name",
                                    "nameEnglish"
                                  ],
                                  "tag-name": "code",
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_PlsInput") +
                                    _vm.$t("CargoMsg.Cargo_AirlineCode")
                                },
                                on: { parentCallBack: _vm.regionChange }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ChineseName"),
                                required: true
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "385px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  filterable: "",
                                  "default-value": _vm.commerceForm.name,
                                  "filter-type": "global",
                                  "filter-tag-names": [
                                    "code",
                                    "name",
                                    "nameEnglish"
                                  ],
                                  "tag-name": "name",
                                  "tag-value": "name",
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_PlsInput") +
                                    _vm.$t("CargoMsg.Cargo_ChineseName")
                                },
                                on: { parentCallBack: _vm.regionChange }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EnglishName"),
                                required: true
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "385px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  filterable: "",
                                  "default-value": _vm.commerceForm.nameEnglish,
                                  "filter-type": "global",
                                  "filter-tag-names": [
                                    "code",
                                    "name",
                                    "nameEnglish"
                                  ],
                                  "tag-name": "nameEnglish",
                                  "tag-value": "nameEnglish",
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_PlsInput") +
                                    _vm.$t("CargoMsg.Cargo_EnglishName")
                                },
                                on: { parentCallBack: _vm.regionChange }
                              })
                            ],
                            1
                          ),
                          _c("br"),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "1180px" },
                                attrs: { type: "textarea", rows: 4 },
                                model: {
                                  value: _vm.commerceForm.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.commerceForm, "remark", $$v)
                                  },
                                  expression: "commerceForm.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_AirlinePersonSetting"))
                    )
                  ]),
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            name: "tabPrePortFreightRateOfficer",
                            label: _vm.$t(
                              "CargoMsg.Cargo_PrePortFreightRateOfficer"
                            )
                          }
                        },
                        [
                          _c("tab-commerce-responsible-person", {
                            ref: "tabPrePortFreightRateOfficer",
                            attrs: {
                              title: _vm.$t(
                                "CargoMsg.Cargo_PrePortFreightRateOfficer"
                              ),
                              "is-edit": _vm.isEdit,
                              type: 1,
                              commerce: _vm.commerceForm
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            name: "tabTrunkLineFreightRates",
                            label: _vm.$t(
                              "CargoMsg.Cargo_PersonChargeTrunkLineFreightRates"
                            )
                          }
                        },
                        [
                          _c("tab-commerce-responsible-person", {
                            ref: "tabTrunkLineFreightRates",
                            attrs: {
                              title: _vm.$t(
                                "CargoMsg.Cargo_PersonChargeTrunkLineFreightRates"
                              ),
                              "is-edit": _vm.isEdit,
                              type: 2,
                              commerce: _vm.commerceForm
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            name: "tabLastMileFreightRates",
                            label: _vm.$t(
                              "CargoMsg.Cargo_PersonChargeLastMileFreightRates"
                            )
                          }
                        },
                        [
                          _c("tab-commerce-responsible-person", {
                            ref: "tabLastMileFreightRates",
                            attrs: {
                              title: _vm.$t(
                                "CargoMsg.Cargo_PersonChargeLastMileFreightRates"
                              ),
                              "is-edit": _vm.isEdit,
                              type: 3,
                              commerce: _vm.commerceForm
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              { staticStyle: { "padding-right": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "confirm",
                      disabled: !_vm.isEdit,
                      type: "primary"
                    },
                    on: { click: _vm.save }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }